// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__u9vjb","skeleton-loading":"skeleton_skeleton-loading__EH-W-"};